import { render, staticRenderFns } from "./TabHelp.vue?vue&type=template&id=53d3bdb8&"
import script from "./TabHelp.vue?vue&type=script&lang=js&"
export * from "./TabHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports